<template>
    <div>
        <div class="radio">
        <tl-radio name="perk" id="manual1" value="manual" label="Assign Perks Manually" v-model="perk"/>
        <tl-radio name="perk" id="bulk1" value="bulk" label="Assign Perks in Bulk" v-model="perk"/>
        </div>
       <div v-if="perk=='manual'">
          <search-dropdown
             class="search"
             v-show="searchemp"
             :employeeData="employeeData"
             @empselected="(emp)=>selectedEmp(emp)"/>
           <selected-employee-card
              class="search"
              v-show="!searchemp"
            >
            <template v-slot:empDetails>
              <span class="input-label"><b>{{selectedemp.name}}</b></span>
              <span class="input-label">{{selectedemp.code}}</span>
              <span class="input-label">{{selectedemp.mail}}</span>
            </template>
            </selected-employee-card>

            <button class="addnewempbtn" @click="addnew" v-show="!searchemp">
             <img src="@/assets/group-7-copy.svg" />
              Add New Perk 
             </button>
        <!-- //add table to show perks -->
        <br><br>
             <data-table
              v-show="!searchemp"
               :columns="columnNames" 
               :tableData="assignedperks" 
               :checkbox="false" 
               :withForm="false" 
               :showinrow="true"
               :showdelete="false"
               :showhistory="false">
               <template v-slot:rowcontent="slotprops">
                 <span 
                  v-if="slotprops.value.record['status']=='Closed' &&
                  slotprops.value.column.key=='cost'"
                  class="input-label">{{slotprops.value.record[slotprops.value.column.key]}}</span>
                 <!-- </span> -->
               </template>
             </data-table>
       </div>
       <div v-if="perk=='bulk'" class="search">
         <tl-select
           label="Select Perk Template"
           :options="perks"
            v-model="perktemplate"
            @change="(val)=>{perktemplate=val}"
           />
            <download-button v-if="perktemplate"></download-button>
            <br>
           <upload/>
       </div>
       <bottom-action-container>
          <template slot="end">
                <btn-grp>
                  <btn text="Back" type="secondary" @click="goBack"/>
                </btn-grp>
            </template>
        </bottom-action-container>
    </div>
</template>

<script>
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import SelectedEmployeeCard from "@/components/dashboard/selectedEmployeeCard.vue";
export default {
  components:{
    SearchDropdown,
    SelectedEmployeeCard
  },
  data(){
    return{
      perk: 'manual',
      perks:['Car Perk','Company Accommodation Perk','Loan Perk','Sweeper, gardener, watchman', 'Gas, electricity, water',
        'Interest free or concessional loans','Holiday expenses','Free or concessional travel',
        'Free meals','Free Education','Gifts, vouchers, etc','Credit card expenses','Club expenses',
        'Use of movable assets by employees','Transfer of assets to employees'],
       employeeData: [
        {
          code: "TL001",
          name: "Nelle Foster",
          designation: "Designer",
          department: "KJHG",
          costcenter: "1500000",
          reportingmgr: "Owen Pearson",
          mail:"nelle.foster@gmail.com"
        },
        {
          code: "TL002",
          name: "Derrick Perry",
          designation: "Designer",
          department: "KJHG",
          costcenter: "1500000",
          reportingmgr: "Owen Pearson",
          mail:"derrick.perry@gmail.com"
        },
        {
          code: "TL003",
          name: "Lucas Singleton",
          designation: "Designer",
          department: "KJHG",
          costcenter: "1500000",
          reportingmgr: "Owen Pearson",
          mail:"lucas.singleton@gmail.com"
        },
        {
          code: "TL004",
          name: "Nelle Foster",
          designation: "Designer",
          department: "KJHG",
          costcenter: "1500000",
          reportingmgr: "Owen Pearson",
          mail:"nelle.foster@gmail.com"
        },
        {
          code: "TL001",
          name: "Nelle Foster",
          designation: "Designer",
          department: "KJHG",
          costcenter: "1500000",
          reportingmgr: "Owen Pearson",
          mail:"nelle.foster@gmail.com"
        }
      ],
      searchemp: true,
      selectedemp: {},
      perktemplate: '',
      columnNames:[{
            label: "Assigned Perks",
            key: "perkname"
          },{
            label: "From",
            key: "from"
          },{
            label: "To",
            key: "to"
          },{
            label: "Status",
            key: "status"
          },{
            label: "Cost /month",
            key: "cost"
          }],
      assignedperks:[{
            perkname: "Car Perk",
            from: "18 Apr 2019",
            to:"-",
            status:"Ongoing",
            cost:"12,004/-"
          },{
            perkname: "Company Accommodation Perk",
            from: "28 Oct 2019",
            to:"-",
            status:"Ongoing",
            cost:"4,044/-"
          },{
            perkname: "Other Perk",
            from: "11 Dec 2018",
            to:"27 Jun 2019",
            status:"Closed",
            cost:"17,303/-"
          },{
            perkname: "Other Perk 2",
            from: "28 Jan 2019",
            to:"08 Aug 2019",
            status:"Closed",
            cost:"9,005/-"
          }]
    }
  },
  methods:{
    selectedEmp(emp){
       this.selectedemp=emp
       this.searchemp=false 
    },
    addnew(){
      this.$router.push(`/dashboard/${this.$route.params.entity_index}/organisation/utilities/newperk`)
    },
    goBack(){this.$router.push(`/dashboard/${this.$route.params.entity_index}/organisation/utilities`)}
  }
}
</script>

<style lang="scss" scoped>
.radio{
  display: flex;
  padding-right: 20px;
}
.search{
   padding-top: 20px; 
}
.addnewempbtn {
  width: 18%;
  display: flex;
  justify-content: center;
  height: 40px;
  background-color: #5d409f;
  border: #5d409f solid 1px;
  color: #ffffff;
  margin-left: 10px;
  border-radius: 4px;
  align-items: center;
  margin-top:20px;
  *:nth-child(n) {
    margin-right: 5px;
  }
}
.footer-width{
  width: 87%;
} 
</style>
